import forOwn from 'mout/object/forOwn'


/**
 * Checks if, with this subtest complete, the test is complete.
 * @param {string} thisSubtestId The id of the subtest currently being submitted.
 * @param {object} destructuredSubtests The destructuredSubtest object from userAssessments (before subtest submission)
 * @returns {boolean} Whether or not the whole test is complete.
 */
export default function testCompleteQ(thisSubtestId, destructuredSubtests) {
  let complete = true
  forOwn(destructuredSubtests, (val, key, o) => {
    if (key !== thisSubtestId) {
      if (!val.complete) {
        complete = false
      }
    }
  })
  return complete
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/testCompleteQ.js